import { useEffect, useCallback } from 'react';
import { useScrollableContainer } from './useScrollableContainer';
export function useScrollAware(onScroll) {
    var _a = useScrollableContainer(), getScrollTop = _a.getScrollTop, getScrollHeight = _a.getScrollHeight, getScrollableContainerOrBody = _a.getScrollableContainerOrBody, getScrollableContainerOrWindow = _a.getScrollableContainerOrWindow;
    var calculateProps = useCallback(function () { return ({
        scrollTop: getScrollTop(),
        scrollHeight: getScrollHeight(),
        bodyWidth: (getScrollableContainerOrBody() || { clientWidth: 0 })
            .clientWidth,
    }); }, [getScrollHeight, getScrollTop, getScrollableContainerOrBody]);
    useEffect(function () {
        var scrollableElement = getScrollableContainerOrWindow();
        if (scrollableElement) {
            var handleScroll_1 = function () { return onScroll(calculateProps()); };
            scrollableElement.addEventListener('scroll', handleScroll_1);
            return function () {
                return scrollableElement.removeEventListener('scroll', handleScroll_1);
            };
        }
    }, [calculateProps, getScrollableContainerOrWindow]);
}
//# sourceMappingURL=useScrollAware.js.map